export const money = (cents, digits = 2) =>
  `$${((cents || 0) / 100).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;

export const day = (iso) => (iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");

export const monthLabel = (key) => {
  const [y, m] = key.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString("en-US", { month: "short", year: "2-digit", timeZone: "UTC" });
};

export const STATUS_STYLE = {
  active: "text-[#4ADE80]", trialing: "text-[#4ADE80]", paid: "text-[#4ADE80]",
  canceling: "text-[#FFD600]", past_due: "text-[#FB923C]",
  canceled: "text-[#F87171]", unpaid: "text-[#F87171]", incomplete_expired: "text-[#F87171]",
  free: "text-muted-foreground",
};
